var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1549 2.28653e-06L3.84494 3.36135e-07C1.73237 1.51449e-07 -1.51455e-07 1.73244 -3.36146e-07 3.84506L-2.28653e-06 26.1549C-2.47123e-06 28.2676 1.73237 30 3.84493 30L26.1549 30C28.2676 30 30 28.2676 30 26.1549L30 3.84507C30 1.73244 28.2676 2.47123e-06 26.1549 2.28653e-06ZM19.4502 13.4297L19.3066 15L16.3125 15C16.3125 19.5 16.3125 25 16.3125 25L12.3125 25C12.3125 25 12.3125 19.5625 12.3125 15L10.3125 15L10.3125 13.4145L10.3125 11L12.3125 11L12.3125 9.18513C12.3125 7.54688 13.0952 4.98725 16.5288 4.98725L19.625 5.00131L19.625 8.4375C19.625 8.4375 17.7398 8.4375 17.3748 8.4375C17.0093 8.4375 16.5 8.61325 16.5 9.39275L16.5 11L19.6714 11L19.4502 13.4297Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.7211cd8578e36104ee942570538c96a1.svg";
export { ForwardRef as ReactComponent };